import type {
    AlertConfiguration, UpsertAlertConfiguration,
    ReportConfiguration, CreateReportConfiguration, UpdateReportConfiguration,
} from '@/models/feedback/Configuration';
import { feedbackRequest } from './feedbackClient';

export const feedbackConfigurationApi = {
    // Alert configuration (keyed by location). Returns null when the location has no config yet.
    getAlert: (locationId: string) =>
        feedbackRequest<AlertConfiguration | null>(`feedback/configuration/alerts/${locationId}`),
    upsertAlert: (locationId: string, item: UpsertAlertConfiguration) =>
        feedbackRequest<void>(`feedback/configuration/alerts/${locationId}`, { method: 'PUT', body: JSON.stringify(item) }),
    deleteAlert: (locationId: string) =>
        feedbackRequest<void>(`feedback/configuration/alerts/${locationId}`, { method: 'DELETE' }),

    // Report configuration
    listReports: (brandId?: string, locationId?: string) => {
        const params = new URLSearchParams();
        if (brandId) params.set('brandId', brandId);
        if (locationId) params.set('locationId', locationId);
        const query = params.toString();
        return feedbackRequest<ReportConfiguration[]>(`feedback/configuration/reports${query ? `?${query}` : ''}`);
    },
    getReport: (id: string) =>
        feedbackRequest<ReportConfiguration>(`feedback/configuration/reports/${id}`),
    createReport: (item: CreateReportConfiguration) =>
        feedbackRequest<{ id: string }>(`feedback/configuration/reports`, { method: 'POST', body: JSON.stringify(item) }),
    updateReport: (id: string, item: UpdateReportConfiguration) =>
        feedbackRequest<void>(`feedback/configuration/reports/${id}`, { method: 'PUT', body: JSON.stringify(item) }),
    deleteReport: (id: string) =>
        feedbackRequest<void>(`feedback/configuration/reports/${id}`, { method: 'DELETE' }),
};
